import { useEffect, useState } from 'react'
import InfoIcon from 'assets/rightIcon.png'

interface Props {
    show: boolean
}

const MachineOrderRestrictionBanner = ({ show }: Props) => {
    const [visible, setVisible] = useState(show)

    useEffect(() => {
        if (show) setVisible(true)
    }, [show])

    if (!visible || !show) return null

    return (
        <div
            className="flex items-center gap-3 p-3 rounded-lg opacity-95 bg-[#e6f3ff]"
            style={{ boxShadow: '0px 6px 12px rgba(148, 163, 184, 0.15)' }}
        >
            <img
                src={InfoIcon}
                alt="info"
                className="shrink-0 w-6 h-6"
            />

            <p className="flex-1 min-w-0 text-sm leading-[18px] font-medium text-[#004f99]">
                <span className="font-semibold">Importante:</span>
                {' '}Solo puede existir una orden de máquina en proceso a la vez. Para procesar una nueva, debes finalizar la actual.
            </p>

            <button
                className="shrink-0 w-4 h-4 text-[#004f99] hover:text-[#003366] cursor-pointer"
                onClick={() => setVisible(false)}
                aria-label="Cerrar"
            >
                <svg
                    className="w-full h-full"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>
        </div>
    )
}

export default MachineOrderRestrictionBanner
